import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import RhodesCRE from './pages/RhodesCRE';
import CaseStudy from './pages/CaseStudy';
import '../styles/css/App.css';
var rhodes = require('../assets/json/rhodes.json');

class App extends Component {
  constructor(props) {
      super(props);
      this.state = {cvData: []};
  }


  render() {
    return (
      <Router>
        <div className="App">
            <Route exact={true} path="/" render={(props) => (
              <RhodesCRE {...props} data={rhodes} />
            )} />
            <Route exact={true} path="/case-study/:case" render={(props) => (
              <CaseStudy />
            )} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/scripts/App.js